import React, { useEffect, useState } from "react";
import { TutorProvider } from "../context/AiTutorContext";
import { LearnProvider } from "../context/LearnContext";
import { PracticeProvider } from "../context/PracticeContext";
import { useRoot } from "../context/RootContext";
import TaskScreen from "../pages/task/TaskScreen";
import { StorageService } from "../utils/StorageUtils";
import { isNotEmptyOrNull, urlString } from "../utils/common-utils";
import { getCookie, setCookie } from "../utils/TutorConstants";
import { useLocation, useNavigate } from "@remix-run/react";
import { redirectToLoginPage } from "../api/login-service";
import { useCustomNavigation } from "../hooks/useCustomNavigation";
import { ROUTES } from "../utils/navigationUtils";

export let loader = async ({ request }) => {
  const url = new URL(request.url);
  const params = Array.from(url.searchParams.entries()).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: value }),
    {}
  );

  return { type: "tasks", params: params };
};

export default function Tasks() {
  useCustomNavigation(ROUTES?.HOME);
  const navigate = useNavigate();
  const location = useLocation();
  const { emailTaskProgressId, emailUserId } = location.state || {};
  const searchParams = new URLSearchParams(location.search);
  let temp = getCookie("taskProgressId");
  let tempEmailUserId = getCookie("emailUserId");
  const [isInitialized, setIsInitialized] = useState(false);
  // let emailTaskProgressId = "";
  const {
    setSelectedIndex,
    setTaskTypeName,
    setSubTopicName,
    setTopicName,
    setSubjectName,
    setTaskCatagory,
  } = useRoot();
  useEffect(() => {
    // Only access localStorage in useEffect (client-side code)
    // Check if we have demo mode in the URL
    if (searchParams.get("isDemo") === "true") {
      console.log("Demo mode detected in URL");
      setCookie("IsDemo", true);
      // Extract all parameters except isDemo
      const userDetails = {};
      searchParams.forEach((value, key) => {
        if (key !== "isDemo") {
          // Handle special values
          if (value === "[object Object]") {
            userDetails[key] = {};
          } else if (value === "true") {
            userDetails[key] = true;
          } else if (value === "false") {
            userDetails[key] = false;
          } else if (
            !isNaN(value) &&
            value.trim() !== "" &&
            !key.startsWith("refresh") &&
            !key.startsWith("idToken")
          ) {
            // Convert numeric strings to numbers, but not for tokens
            userDetails[key] = Number(value);
          } else {
            userDetails[key] = value;
          }
        }
      });

      // Store in localStorage
      try {
        StorageService.setItem(
          "user_additional_details",
          JSON.stringify(userDetails)
        );
        StorageService.setItem("user_details", JSON.stringify(userDetails));
        StorageService.setItem("xUserId", userDetails?._id);
        console.log(
          "Demo mode activated via React router, stored user details:",
          userDetails
        );
      } catch (err) {
        console.error("Error storing data in localStorage:", err);
      }
    }

    setTaskTypeName("Top Priority");
    setSubTopicName("");
    setTopicName("");
    setSubjectName("");
    setTaskCatagory("");
    setSelectedIndex(0);
    StorageService.removeItem("subjectMasterUUid");
    StorageService.removeItem("topicMasterUUid");
    StorageService.removeItem("videoEvents");
    StorageService.removeItem("backUpObject");
    StorageService.removeItem("assesmentInfo");
    StorageService.removeItem("ReviewJourneyId");
    StorageService.removeItem("activity");
    setIsInitialized(true);

    if (
      isNotEmptyOrNull(StorageService?.getItem("redirectObject")) ||
      !isNotEmptyOrNull(StorageService?.getItem("student_id"))
    ) {
      redirectToLoginPage();
    }
  }, [location.search]);

  if (!isInitialized) {
    return null;
  }
  return (
    <TutorProvider>
      <PracticeProvider>
        {/* <LearnProvider> */}
        <TaskScreen
          emailTaskProgressId={
            isNotEmptyOrNull(emailTaskProgressId) ? emailTaskProgressId : temp
          }
          emailUserId={
            isNotEmptyOrNull(emailUserId) ? emailUserId : tempEmailUserId
          }
        />
        {/* </LearnProvider> */}
      </PracticeProvider>
    </TutorProvider>
  );
}
